(() => {
  if (window.k2GalleryVideoLoaded) return;
  window.k2GalleryVideoLoaded = true;
  const init = (scope = document) => {
    scope.querySelectorAll('[data-k2-gallery-video]').forEach(box => {
      if (box.dataset.ready) return;
      box.dataset.ready = 'true';
      const button = box.querySelector('[data-k2-video-play]');
      const error = box.querySelector('[role="status"]');
      let video;
      const showCover = () => { button.hidden = false; };
      const fail = () => { if (video) video.pause(); showCover(); error.hidden = false; };
      button.addEventListener('click', () => {
        if (!video) {
          box.append(box.querySelector('template').content.cloneNode(true));
          video = box.querySelector('video');
          video.addEventListener('play', () => {
            document.querySelectorAll('[data-k2-gallery-video] video').forEach(other => { if (other !== video) other.pause(); });
            button.hidden = true;
          });
          video.addEventListener('ended', showCover);
          video.addEventListener('error', fail);
        }
        error.hidden = true;
        button.hidden = true;
        video.focus();
        const attempt = video.play();
        if (attempt) attempt.catch(fail);
      });
      const observer = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting && video) video.pause();
      }, { threshold: .25 });
      observer.observe(box);
      const unload = event => {
        if (!event.target.contains(box)) return;
        if (video) video.pause();
        observer.disconnect();
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) document.querySelectorAll('[data-k2-gallery-video] video').forEach(video => video.pause());
  });
})();
